import Vue from 'vue';
import scrollfullSceenVue from './touchFullSceen.vue';
import merge from '@/utils/merge';

const defaults = {

};
const scrollfullSceenConstructor = Vue.extend(scrollfullSceenVue);

scrollfullSceenConstructor.prototype.close = function() {
    if (this._el != null) {
        document.body.removeChild(this._el) //从body中移除dom
    }
    if (this._instance != null) {
        this._instance.$destroy() //销毁组件
    }
    if (this._vm != null) {
        this._vm = null //让GC回收
    }
}

const ScrollfullSceen = (options => {
    options = merge({}, defaults, options);
    let instance = new scrollfullSceenConstructor({
        data: options
    });
    instance._vm = instance.$mount()
    instance._el = instance.$el
    instance._instance = instance
    document.body.appendChild(instance.$el) // 把生成的提示的dom插入body中
    return instance;
})

export default ScrollfullSceen